import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import gitIcon from "../assets/img/footer-icons/github-icon.svg"
import linkedInIcon from "../assets/img/footer-icons/linkedin-icon.svg"
import instagramIcon from "../assets/img/footer-icons/instagram-icon.svg"
import mediumIcon from "../assets/img/footer-icons/medium-icon.svg"
import logo from "../assets/img/logo-attica.svg"
import footerLine from "../assets/img/footer-line.svg"
import { FormattedMessage } from "react-intl"

interface FooterProps {
  copyRight: string,
  pioneerMessage: string
}

const Footer = ({ copyRight, pioneerMessage }: FooterProps) => (
  <footer>
    <div>
      <img src={footerLine} className="footerLine" alt="" />
    </div>

    <div className="container-large footer">
      <div className="container grid-cards-2">
        <div className="cards contact-part">
          <h3>
            <FormattedMessage id="footer_title_2" />
          </h3>
          <p>
            <FormattedMessage id="footer_paragaph_1" />
          </p>
          <a target="_blank" href="mailto:hello@atticalabs.com">
            hello@atticalabs.com
          </a>
        </div>
        <div className="cards">
          <div className="social-networks">
            <ul>
              {/* <li><a href="#"><img src={twitterIcon} alt="Twitter Icon" className="icon" /></a></li> */}
              <li>
                <a target="_blank" href="https://medium.com/@atticalabs">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1.01025"
                      y="0.75"
                      width="21.2397"
                      height="21.2397"
                      rx="2.25"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M16.408 7.96568L17.3152 7.026V6.82031H14.1724L11.9325 12.8564L9.38422 6.82031H6.08886V7.026L7.14862 8.40731C7.2519 8.50938 7.30591 8.65864 7.29217 8.80893V14.2372C7.32486 14.4327 7.26611 14.6337 7.13915 14.7758L5.94531 16.3423V16.5454H9.33022V16.3397L8.13638 14.7758C8.00705 14.6332 7.94593 14.4357 7.97199 14.2372V9.5419L10.9433 16.548H11.2887L13.8436 9.5419V15.123C13.8436 15.2703 13.8436 15.3005 13.7545 15.397L12.8354 16.3597V16.5659H17.2943V16.3602L16.4084 15.4211C16.3307 15.3575 16.2905 15.2508 16.307 15.1472V8.23958C16.2905 8.13546 16.3303 8.02877 16.408 7.96568Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.instagram.com/atticalabs/">
                  <svg
                    width="24"
                    height="23"
                    viewBox="0 0 24 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0)">
                      <path
                        d="M23.471 6.68554C23.4177 5.47729 23.2223 4.64663 22.9424 3.92685C22.6537 3.16283 22.2094 2.47879 21.6274 1.91015C21.0588 1.33267 20.3703 0.883932 19.6151 0.5997C18.8911 0.319805 18.0648 0.124417 16.8566 0.0711449C15.6393 0.0133614 15.2529 0 12.1655 0C9.07819 0 8.69175 0.0133614 7.47899 0.0666333C6.27074 0.119905 5.44008 0.315467 4.72048 0.595188C3.95628 0.883932 3.27225 1.32815 2.70361 1.91015C2.12612 2.47879 1.67756 3.16734 1.39316 3.92252C1.11326 4.64663 0.917874 5.47278 0.864602 6.68103C0.806818 7.8983 0.793457 8.28474 0.793457 11.3721C0.793457 14.4594 0.806818 14.8459 0.86009 16.0586C0.913362 17.2669 1.10892 18.0975 1.38882 18.8173C1.67756 19.5813 2.12612 20.2654 2.70361 20.834C3.27225 21.4115 3.96079 21.8602 4.71597 22.1445C5.44008 22.4244 6.26623 22.6198 7.47465 22.673C8.68724 22.7265 9.07385 22.7397 12.1612 22.7397C15.2485 22.7397 15.635 22.7265 16.8477 22.673C18.056 22.6198 18.8866 22.4244 19.6062 22.1445C21.1345 21.5536 22.3427 20.3454 22.9336 18.8173C23.2133 18.0932 23.4088 17.2669 23.4621 16.0586C23.5154 14.8459 23.5287 14.4594 23.5287 11.3721C23.5287 8.28474 23.5242 7.8983 23.471 6.68554ZM21.4232 15.9698C21.3743 17.0803 21.1877 17.68 21.0323 18.0798C20.6502 19.0705 19.8639 19.8567 18.8733 20.2388C18.4735 20.3943 17.8694 20.5808 16.7632 20.6296C15.5638 20.683 15.2041 20.6962 12.17 20.6962C9.13597 20.6962 8.77174 20.683 7.57668 20.6296C6.46613 20.5808 5.86643 20.3943 5.46663 20.2388C4.97365 20.0566 4.52492 19.7679 4.16069 19.3903C3.7831 19.0216 3.49436 18.5773 3.31216 18.0843C3.15668 17.6845 2.97014 17.0803 2.92138 15.9743C2.86794 14.7749 2.85475 14.415 2.85475 11.3809C2.85475 8.34686 2.86794 7.98263 2.92138 6.78775C2.97014 5.67719 3.15668 5.07749 3.31216 4.67769C3.49436 4.18454 3.7831 3.73598 4.1652 3.37158C4.53377 2.99399 4.97799 2.70524 5.47114 2.52322C5.87094 2.36774 6.47515 2.1812 7.58119 2.13227C8.78059 2.07899 9.14048 2.06563 12.1744 2.06563C15.213 2.06563 15.5727 2.07899 16.7677 2.13227C17.8783 2.1812 18.478 2.36774 18.8778 2.52322C19.3708 2.70524 19.8195 2.99399 20.1837 3.37158C20.5613 3.74031 20.8501 4.18454 21.0323 4.67769C21.1877 5.07749 21.3743 5.68153 21.4232 6.78775C21.4765 7.98715 21.4898 8.34686 21.4898 11.3809C21.4898 14.415 21.4765 14.7704 21.4232 15.9698Z"
                        fill="white"
                      />
                      <path
                        d="M12.1657 5.53125C8.94079 5.53125 6.32422 8.14765 6.32422 11.3728C6.32422 14.5979 8.94079 17.2143 12.1657 17.2143C15.3909 17.2143 18.0073 14.5979 18.0073 11.3728C18.0073 8.14765 15.3909 5.53125 12.1657 5.53125ZM12.1657 15.162C10.0736 15.162 8.37649 13.4651 8.37649 11.3728C8.37649 9.28041 10.0736 7.58352 12.1657 7.58352C14.2581 7.58352 15.955 9.28041 15.955 11.3728C15.955 13.4651 14.2581 15.162 12.1657 15.162Z"
                        fill="white"
                      />
                      <path
                        d="M19.6017 5.30123C19.6017 6.05432 18.991 6.66495 18.2378 6.66495C17.4847 6.66495 16.874 6.05432 16.874 5.30123C16.874 4.54796 17.4847 3.9375 18.2378 3.9375C18.991 3.9375 19.6017 4.54796 19.6017 5.30123Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="22.7397"
                          height="22.7397"
                          fill="white"
                          transform="translate(0.753418)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/atticalabs/"
                >
                  <svg
                    width="24"
                    height="23"
                    viewBox="0 0 24 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.56111 17.053H8.0392C8.24312 17.053 8.40841 16.872 8.40841 16.6488V9.57606C8.40841 9.3528 8.24312 9.17188 8.0392 9.17188H6.56111C6.35717 9.17188 6.19189 9.3528 6.19189 9.57606V16.6488C6.19189 16.872 6.35717 17.053 6.56111 17.053Z"
                      fill="white"
                    />
                    <path
                      d="M6.56111 7.92886H8.0392C8.24312 7.92886 8.40841 7.74791 8.40841 7.52468V6.08778C8.40841 5.86454 8.24312 5.68359 8.0392 5.68359H6.56111C6.35717 5.68359 6.19189 5.86454 6.19189 6.08778V7.52468C6.19189 7.74791 6.35717 7.92886 6.56111 7.92886Z"
                      fill="white"
                    />
                    <path
                      d="M17.0058 9.99247C16.7981 9.69317 16.4918 9.44703 16.0869 9.2541C15.6819 9.06131 15.2349 8.96484 14.7459 8.96484C13.753 8.96484 12.9118 9.37963 12.2221 10.2094C12.0848 10.3745 11.9851 10.3384 11.9851 10.1151V9.5763C11.9851 9.35304 11.8198 9.17212 11.6158 9.17212H10.2955C10.0915 9.17212 9.92627 9.35304 9.92627 9.5763V16.6491C9.92627 16.8723 10.0916 17.0533 10.2955 17.0533H11.7736C11.9775 17.0533 12.1428 16.8723 12.1428 16.6491V14.1893C12.1428 13.1646 12.1993 12.4622 12.3124 12.0823C12.4254 11.7024 12.6345 11.3973 12.9395 11.167C13.2445 10.9367 13.5889 10.8215 13.9728 10.8215C14.2726 10.8215 14.529 10.9021 14.742 11.0634C14.955 11.2246 15.1088 11.4504 15.2035 11.7412C15.2982 12.032 15.3455 12.6724 15.3455 13.6626V16.649C15.3455 16.8723 15.5107 17.0532 15.7147 17.0532H17.1928C17.3967 17.0532 17.5619 16.8723 17.5619 16.649V12.6436C17.5619 11.9356 17.5212 11.3915 17.4397 11.0116C17.3583 10.6316 17.2136 10.2919 17.0058 9.99247Z"
                      fill="white"
                    />
                    <rect
                      x="1.50684"
                      y="1"
                      width="20.7397"
                      height="20.7397"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a target="_blank" href="https://github.com/atticalabs">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0)">
                      <path
                        d="M0.174222 9.91333C-0.563872 14.5617 1.50165 20.168 7.87067 22.2364C7.98437 22.2572 8.08954 22.2667 8.18808 22.2667C8.92902 22.2667 9.43877 21.7152 9.43877 21.0349C9.34686 20.5394 9.80165 18.5317 8.56708 18.8017C6.18035 19.3096 5.89421 17.9765 5.53038 17.2791C6.55935 18.5999 8.10565 18.5667 9.27201 18.0551C9.91914 17.7708 9.58089 17.047 9.88788 16.7826C10.3578 16.379 10.1191 15.6049 9.50225 15.5376C7.30976 15.296 5.27929 14.5892 5.27929 11.0825C5.27929 9.02837 6.70526 8.84456 6.31205 7.98519C6.29784 7.95392 5.99654 7.27078 6.26942 6.23328C7.6139 6.48152 8.23261 7.44607 8.87785 7.27268C10.4763 6.83683 12.2358 6.83683 13.8332 7.27268C14.5003 7.45175 14.9768 6.51374 16.4274 6.22759C16.8453 7.79474 15.9793 8.17753 16.525 8.76402C17.1238 9.40831 17.428 10.1881 17.428 11.0825C17.428 16.3544 12.9587 14.8317 12.5949 16.0284C12.5115 16.3013 12.5996 16.596 12.8175 16.7788C13.3955 17.2649 13.3197 18.5127 13.2581 19.5161C13.1946 20.5565 13.1397 21.4537 13.7148 21.9597C13.9175 22.1397 14.2785 22.3321 14.9314 22.1994C21.217 20.1803 23.2977 14.5987 22.571 9.9607C20.585 -2.70533 2.17532 -2.69017 0.174222 9.91333ZM8.00995 20.3149L8.01374 20.7933C7.51821 20.6218 7.05204 20.4238 6.6162 20.2031C7.01888 20.3063 7.48125 20.3509 8.00995 20.3149ZM8.36052 16.8091C8.35579 16.8338 8.35105 16.8594 8.34631 16.8849C7.5381 17.1237 6.91655 16.8859 6.49208 16.1724C6.49208 16.1715 6.49208 16.1715 6.49113 16.1705C7.13542 16.5154 7.79961 16.7011 8.36052 16.8091ZM11.3697 1.89568C22.5814 1.89568 25.1102 17.3085 14.6566 20.7895C14.6206 20.5081 14.6537 19.9776 14.6765 19.6033C14.7314 18.7022 14.7959 17.6524 14.4747 16.775C19.2955 15.7716 19.6982 10.478 17.842 8.11973C18.0723 7.21772 17.9794 5.09819 17.1513 4.83858C16.9561 4.77699 15.9149 4.55054 13.8948 5.82112C12.2452 5.42697 10.4649 5.42602 8.81532 5.82112C7.80719 5.18915 5.53511 4.16112 5.09927 5.25263C4.59331 6.52416 4.71364 7.55218 4.86429 8.12352C3.21661 10.2118 3.71025 13.708 5.37025 15.3491C4.42939 14.899 3.13323 14.7455 2.85372 15.6466C2.54768 16.6291 3.71783 16.5097 4.44455 18.3033C4.51372 18.5269 4.64163 18.7894 4.83776 19.05C-1.61558 13.7772 1.49786 1.89568 11.3697 1.89568Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="22.7397" height="22.7397" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="cards copyright">
          <p>
            {copyRight}
            {new Date().getFullYear()}{" "}
            <FormattedMessage
              id="footer_copyright_paragraph"
              values={{
                breakeLine: <br />,
              }}
            />
          </p>
          <p>
            {pioneerMessage}
            </p>
        </div>
        <div className="cards logo">
          <svg
            className="logoClass"
            width="142"
            height="49"
            viewBox="0 0 142 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M65.2054 35.3164L64.9529 33.0482C64.3038 33.9192 63.4383 34.6087 62.3564 35.1168C61.2745 35.6067 60.1024 35.8607 58.8222 35.8607C57.001 35.8607 55.3962 35.4434 53.9717 34.5906C52.5472 33.7377 51.4292 32.5583 50.6178 31.0523C49.8064 29.5462 49.4097 27.8225 49.4097 25.8991C49.4097 23.9576 49.8064 22.2338 50.6178 20.7278C51.4292 19.2399 52.5472 18.0605 53.9717 17.2076C55.3962 16.3548 57.019 15.9375 58.8222 15.9375C60.1024 15.9375 61.2745 16.1915 62.3384 16.6814C63.4022 17.1895 64.2677 17.8609 64.9529 18.75L65.2054 16.4818H69.7313V35.3164H65.2054ZM59.6516 31.2156C61.1302 31.2156 62.3203 30.7257 63.258 29.7277C64.1956 28.7297 64.6464 27.4596 64.6464 25.8991C64.6464 24.3386 64.1776 23.0685 63.258 22.0705C62.3203 21.0725 61.1302 20.5826 59.6516 20.5826C58.173 20.5826 56.9649 21.0725 56.0453 22.0705C55.1077 23.0685 54.6569 24.3386 54.6569 25.8991C54.6569 27.4596 55.1257 28.7297 56.0453 29.7277C56.983 30.7257 58.1911 31.2156 59.6516 31.2156Z"
              fill="white"
            />
            <path
              d="M90.3891 16.607V10.7578H85.2688V16.607H82.9628H82.9265H79.7127V10.7578H74.6106V16.607H71.7236V20.9849H74.6106V35.4626H79.7127V20.9849H82.9265H82.9628H85.2688V35.4626H90.3891V20.9849H93.6392V16.607H90.3891Z"
              fill="white"
            />
            <path
              d="M118.118 29.0745L121.133 32.2861C119.099 34.6631 116.417 35.8607 113.106 35.8607C111.09 35.8607 109.314 35.4434 107.761 34.5906C106.207 33.7377 104.986 32.5583 104.117 31.0523C103.229 29.5462 102.804 27.8225 102.804 25.8991C102.804 23.9757 103.229 22.2701 104.098 20.7641C104.968 19.2762 106.17 18.0968 107.687 17.2258C109.203 16.3548 110.942 15.9375 112.884 15.9375C116.176 15.9375 118.803 17.0262 120.726 19.2217L117.748 22.4334C116.509 21.3084 115.011 20.7459 113.291 20.7459C111.774 20.7459 110.553 21.2177 109.61 22.1612C108.667 23.1048 108.204 24.3568 108.204 25.881C108.204 27.4414 108.667 28.6934 109.61 29.6188C110.553 30.5624 111.811 31.016 113.365 31.016C115.103 31.0341 116.694 30.3809 118.118 29.0745Z"
              fill="white"
            />
            <path
              d="M137.327 35.3164L137.075 33.0482C136.426 33.9192 135.56 34.6087 134.478 35.1168C133.397 35.6067 132.225 35.8607 130.944 35.8607C129.123 35.8607 127.518 35.4434 126.094 34.5906C124.669 33.7377 123.551 32.5583 122.74 31.0523C121.928 29.5462 121.532 27.8225 121.532 25.8991C121.532 23.9576 121.928 22.2338 122.74 20.7278C123.551 19.2399 124.669 18.0605 126.094 17.2076C127.518 16.3548 129.141 15.9375 130.944 15.9375C132.225 15.9375 133.397 16.1915 134.46 16.6814C135.524 17.1895 136.39 17.8609 137.075 18.75L137.327 16.4818H141.853V35.3164H137.327ZM131.774 31.2156C133.252 31.2156 134.442 30.7257 135.38 29.7277C136.318 28.7297 136.768 27.4596 136.768 25.8991C136.768 24.3386 136.3 23.0685 135.38 22.0705C134.442 21.0725 133.252 20.5826 131.774 20.5826C130.295 20.5826 129.087 21.0725 128.167 22.0705C127.23 23.0685 126.779 24.3386 126.779 25.8991C126.779 27.4596 127.248 28.7297 128.167 29.7277C129.087 30.7257 130.295 31.2156 131.774 31.2156Z"
              fill="white"
            />
            <path
              d="M95.6318 35.4622V16.7344H100.812V35.4622H95.6318Z"
              fill="white"
            />
            <path
              d="M100.812 10.7578H95.6318V15.1409H100.812V10.7578Z"
              fill="white"
            />
            <path
              d="M44.1563 37.9004L36.4652 24.0639L43.9731 10.2275C44.0464 10.1004 44.0464 9.9733 44.0098 9.8462C43.9731 9.71909 43.8633 9.61014 43.7534 9.55567L22.2 0.0408556C22.0718 -0.0136185 21.9254 -0.0136185 21.7972 0.0408556L0.280426 9.64646C0.152242 9.70094 0.0606807 9.80988 0.0240565 9.93699C-0.0125678 10.0641 -0.0125669 10.2094 0.0606816 10.3183L7.77008 24.1547L0.170554 37.9912C0.0973055 38.1183 0.0973061 38.2454 0.13393 38.3725C0.170555 38.4996 0.280426 38.6085 0.390299 38.663L22.0169 48.1778C22.0719 48.2141 22.1451 48.2141 22.2183 48.2141C22.2916 48.2141 22.3465 48.196 22.4198 48.1778L43.9548 38.5722C44.083 38.5177 44.1746 38.4088 44.2112 38.2817C44.2478 38.1546 44.2295 38.0093 44.1563 37.9004ZM17.4572 41.8588L5.48107 36.6293L9.98585 28.4582L17.4572 41.8588ZM5.3712 11.771L17.2558 6.4688L9.87598 19.8513L5.3712 11.771ZM12.2932 24.1547L21.907 6.63223L31.5209 24.0639L21.9986 41.5865L12.2932 24.1547ZM26.5583 6.45065L38.4612 11.6802L33.9564 19.8513L26.5583 6.45065ZM38.4429 36.5385L26.5583 41.8588L33.9381 28.4764L38.4429 36.5385Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
